import { z } from "zod";

export const contactSaleSchema = z.object({
  firstName: z
    .string()
    .min(1, "First name is required")
    .max(50, "First name must be 50 characters or less"),
  lastName: z
    .string()
    .min(1, "Last name is required")
    .max(50, "Last name must be 50 characters or less"),
  email: z.string().email("Please enter a valid email address").min(1, "Email is required"),
  jobTitle: z
    .string()
    .min(1, "Job title is required")
    .max(100, "Job title must be 100 characters or less"),
  companyName: z
    .string()
    .min(1, "Company name is required")
    .max(100, "Company name must be 100 characters or less"),
  companySize: z.string().min(1, "Company size is required"),
  country: z.string().min(1, "Country is required"),
  phoneNumber: z
    .string()
    .min(1, "Phone number is required")
    .max(20, "Phone number must be 20 characters or less"),
  reasonForContact: z.string().min(1, "Reason for contact is required"),
  additionalDetails: z.string().optional().nullable(),
  marketingOptIn: z.boolean().optional().default(false),
});

export type ContactSaleSchema = z.output<typeof contactSaleSchema>;
